export function getCachedData(key, expiryMs) {
  try {
    const cached = sessionStorage.getItem(key);
    if (!cached) return null;
    const { data, timestamp } = JSON.parse(cached);
    if (Date.now() - timestamp < expiryMs) return data;
    sessionStorage.removeItem(key);
  } catch (e) {
    sessionStorage.removeItem(key);
  }
  return null;
}

export function setCachedData(key, data) {
  sessionStorage.setItem(key, JSON.stringify({ data, timestamp: Date.now() }));
}
